import { Card, CardActionArea, CardMedia, CardContent, Typography, Grid } from '@mui/material';
import machineDefaultImage from '../../images/machineImageEmpty.svg';
import { entityGridPhotoUrl } from '../entityImage/entityImageConfig';
import { useNavigate } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import React, { useCallback } from 'react';
import '../../css/regions/regionCardView.css';

const RegionGridData = React.memo(({ index, style, data }) => {

    const { regions, columns, filteredRegionCount } = data;
    const navigate = useNavigate();
    const startIndex = index * columns;
    const endIndex = Math.min(startIndex + columns, filteredRegionCount);

    const handleRegionClick = useCallback((regionId) => navigate(`region_details/${regionId}`), [navigate]);

    return (
        <Grid style={style} key={index} container spacing={2}>
            {Array.from({ length: endIndex - startIndex })?.map((_, idx) => {
                const regionIndex = startIndex + idx;
                const region = regions[regionIndex];

                return (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={region ? region.id : `skeleton-${regionIndex}`}>
                        <Card className='regions_gridview_card'>
                            <CardActionArea onClick={region ? () => handleRegionClick(region.id) : undefined}>
                                {region ? (
                                    <>
                                        <CardMedia
                                            component="img"
                                            height="192"
                                            loading='lazy'
                                            decoding='async'
                                            image={entityGridPhotoUrl(region, 'region', { size: 'small', fallback: machineDefaultImage })}
                                            alt={region.name}
                                        />
                                        <CardContent className='regions_gridview_card_CardContent'>
                                            <Typography className='regions_gridview_region_name' component="div">{region?.name}</Typography>
                                            <Typography className='regions_gridview_region_adress' component="div">{region?.description}</Typography>
                                        </CardContent>
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rectangular" height={192} />
                                        <CardContent className='machines_gridview_card_CardContent'>
                                            <Skeleton variant="text" />
                                            <Skeleton variant="text" />
                                        </CardContent>
                                    </>
                                )}
                            </CardActionArea>
                        </Card>
                    </Grid>
                );
            })}
        </Grid>
    );
});

export default RegionGridData;